import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../common/Button';
import Icon from '../common/Icon';
import { useAuth } from '../../context/AuthContext';
import NotificationBell from '../common/NotificationBell';

const Header = ({
  title,
  showBack = false,
  backTo = -1,
  onBackClick,
  actions = [],
  breadcrumbs = [],
  className = ''
}) => {
  const navigate = useNavigate();
  const { user, logout, isAuthenticated, getHomeRoute } = useAuth();

  const handleBack = () => {
    if (typeof onBackClick === 'function') {
      onBackClick();
      return;
    }
    if (typeof backTo === 'number') {
      if (window.history.length > 1) {
        navigate(backTo);
      } else {
        navigate(isAuthenticated ? getHomeRoute() : '/');
      }
      return;
    }
    navigate(backTo);
  };

  return (
    <div
      className={`app-header ${className}`.trim()}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        flexWrap: 'wrap',
        gap: '8px',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          flex: '1 1 auto',
          minWidth: 0,
        }}
      >
        {showBack && (
          <Button
            variant="secondary"
            size="sm"
            onClick={handleBack}
            className="p-2"
            aria-label="Go back"
          >
            <Icon name="arrowLeft" size={16} />
          </Button>
        )}

        {title && (
          <div style={{ minWidth: 0 }}>
            <h1
              style={{
                fontFamily: 'Outfit, sans-serif',
                fontWeight: '700',
                fontSize: '20px',
                color: 'var(--text)',
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {title}
            </h1>
            {breadcrumbs.length > 0 && (
              <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '4px' }}>
                {breadcrumbs.map((crumb, index) => (
                  <span key={index}>
                    {index > 0 && ' / '}
                    {crumb}
                  </span>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      <div
        className="app-header-actions"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          flexShrink: 0,
        }}
      >
        {actions.map((action, index) => (
          action ? (
            <Button
              key={index}
              variant={action.variant || 'secondary'}
              size={action.size || 'sm'}
              onClick={action.onClick}
              icon={action.icon}
              disabled={action.disabled}
              className={action.className}
              aria-label={action.label || action.icon || 'Action'}
            >
              {action.label || (action.icon ? <Icon name={action.icon} size={16} /> : null)}
            </Button>
          ) : null
        ))}

        {isAuthenticated ? (
          <div className="app-header-user-block" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <NotificationBell />

            <div
              className="app-header-avatar"
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontWeight: '600',
                fontSize: '14px',
                background: 'linear-gradient(135deg, var(--primary), var(--primary-dark))',
              }}
              title={user?.username || user?.email || 'Account'}
            >
              {user?.username?.charAt(0)?.toUpperCase() || user?.email?.charAt(0)?.toUpperCase() || 'U'}
            </div>

            <Button
              variant="secondary"
              size="sm"
              onClick={() => navigate(getHomeRoute())}
              className="p-2"
              title="Home"
              aria-label="Home"
            >
              <Icon name="home" size={16} />
            </Button>

            <Button
              variant="secondary"
              size="sm"
              onClick={logout}
              className="p-2"
              title="Logout"
              aria-label="Logout"
            >
              <Icon name="out" size={16} />
            </Button>
          </div>
        ) : (
          <Button
            variant="primary"
            size="sm"
            onClick={() => navigate('/login')}
          >
            Login
          </Button>
        )}
      </div>
    </div>
  );
};

export default Header;
